export var EncFieldGroupType;
(function (EncFieldGroupType) {
    EncFieldGroupType["SHARED_AXIS"] = "SHARED_AXIS";
})(EncFieldGroupType || (EncFieldGroupType = {}));
export var EncFieldGroup;
(function (EncFieldGroup) {
    EncFieldGroup.SharedAxis = {
        make(id, name) {
            return {
                id,
                type: EncFieldGroupType.SHARED_AXIS,
                name,
            };
        },
    };
})(EncFieldGroup || (EncFieldGroup = {}));
